import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from 'ag-grid-enterprise';
import { AddInUtilities } from './app/services/utilities/addin-utilities';

// AG Grid License
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-090874}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Advent_Software,_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Tamale}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Tamale}_need_to_be_licensed___{Tamale}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{27_December_2026}____[v3]_[01]_MTc5ODMyOTYwMDAwMA==9cf32a0e49b2bfee7f1b4101376f5608');

if (environment.production) {
    enableProdMode();
    if (!environment.isOfficeAddin) {
        // keep console logs from surfacing on Tamale Web but enabling it for Add-in for debug purpose.
        window.console.log = () => { };
    }
}

if (environment.isOfficeAddin) {
    // Office.initialize is already set in index-add-in.html
    // Wait for Office.onReady() before bootstrapping Angular
    const bootstrapAngular = () => {
        if (typeof Office !== 'undefined' && Office.onReady) {
            Office.onReady()
                .then(() => {
                    return platformBrowserDynamic().bootstrapModule(AppModule);
                })
                .catch(err => {
                    console.error('[Office Add-in] Initialization error:', err);
                });
        } else {
            // Office.js not ready yet, retry
            setTimeout(bootstrapAngular, 200);
        }
    };

    bootstrapAngular();
} else {
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.error(err));
}
